import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function HotComics() {
  const hotComics = [...comics].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="mb-6">
        <h2 className="text-lg md:text-xl font-bold text-foreground-950">
          热门推荐
        </h2>
        <p className="text-sm text-foreground-500 mt-1">
          女神漫画下拉式免费全集 · 精选热门漫画推荐
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {hotComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}